import * as React from 'react';
import * as _ from "lodash";
import { useHistory, useParams } from 'react-router-dom';
import { IProfile } from '@assetmark/profile/dist/profileComponent';
import { SideBarComponent } from '../common/sidebar/sidebar.component';
import styles from './aboutyou.module.css';

import { EGoalType, GetGoalTypeDisplayText } from '../../helpers/goal.helper';
import { TUnderlineDropdownItem } from '@assetmark/common-elements/dist';
import { redirectTo } from '../../helpers/historyhelpers';
import { useLead } from '../../contexts/lead/lead.context';

import { About } from '@assetmark/profile/dist/components/about/about';
import { InvestmentAmount } from '@assetmark/profile/dist/components/investment/investmentAmount';
import { InvestmentReason } from '@assetmark/profile/dist/components/reason/investmentReason';
import { useEffect, useState } from 'react';
import { TScreenType } from '../../models/screen-type';
import { TAddUpdateLeadName } from '../../models/add-update-lead-request';
import { useApp } from '../../contexts/app/app.context';
import { TUpdateLeadStrategy } from '../../models/update-lead';
import { TLeadProfileResponse } from '../../models/lead-profile-response';
import { TAmountReason } from '../../models/amount-reason';
import { LeadApi } from '../../apis/lead.api';
import { TLastPageRequest } from '../../models/last-update-page-request';
import { getLastVisitedPageCategory } from '../../helpers/pagehelper';
import { getRiskProfileId } from '../../helpers/storage.helper';
import { LocalStorageUtils } from '@assetmark/ui-kit/dist/utils/local-storage.utils';
import { LEAD_ID_KEY } from '../../constants/storage.constant';

type TAboutYouProps = {
	leadData: TLeadProfileResponse;
	leadStrategy: TAmountReason;
	onAddUpdateName: (lead: TAddUpdateLeadName, lastPage: TLastPageRequest, leadId: string) => void;
	onAddUpdateAmountReason: (lead: TUpdateLeadStrategy, lastPage: TLastPageRequest) =>  void;
	onBackButtonClick: (backScreen: string) => void;
}
export const AboutYouComponent: React.FC<TAboutYouProps> = ({ leadData, leadStrategy, onAddUpdateName, onAddUpdateAmountReason, onBackButtonClick }) => {
	const { subModule } = useParams<{subModule: string}>();
	const { user } = useApp();
	const { agentId, leadProfileId, leadStrategyId, leadProfile, setLeadProfile, updateLeadData, investorNavState } = useLead();
	const history = useHistory();
	const [leadProfileCopy, setCopy] = useState(_.cloneDeep(leadProfile));
	
	const investmentTypeDropdownItems: TUnderlineDropdownItem[] = [] as TUnderlineDropdownItem[];
	investmentTypeDropdownItems.push(
		{ value: EGoalType.Retirement, text: GetGoalTypeDisplayText(EGoalType.Retirement) },
		{ value: EGoalType.GeneralSavings, text: GetGoalTypeDisplayText(EGoalType.GeneralSavings) },
		{ value: EGoalType.Unknown, text: GetGoalTypeDisplayText(EGoalType.Unknown) },
	);
	
	useEffect(() => {
		if(leadData.leadProfileId.isSome()) {
			updateLeadData(leadData);
		}
	}, [leadData]);

	useEffect(() => {
		if(leadStrategy.investmentAmount > 0) {
			setLeadProfile({
				...leadProfile,
				investmentInfo: { InvestmentAmount: leadStrategy.investmentAmount },
				investmentReason: leadStrategy.investmentReason,
			});
		}
	}, [leadStrategy]);

	const handleBackButton = (backScreen: string, data: any) => {
		//console.log('data object :>> ', data);
		//console.log('leadProfile object :>> ', leadProfile);
		//console.log('leadProfileCopy object :>> ', leadProfileCopy);
		LeadApi.redirectToPage$.next(backScreen);
	};

	const handleNextName = (data: IProfile) => {
		onAddUpdateName(
			{
				firstName: data.Investor && data.Investor.FirstName,
				lastName: data.Investor && data.Investor.LastName,
				emailAddress: data.Investor && data.Investor.EmailAddress,
				age: data.Investor && data.Investor.Age,
				agentId: agentId || user.roles[0].aplId.getOrElse(""), // on first load you will not get agentId set in lead context
			},
			{
				currentRoute: 'about',
				leadId: leadProfileId,
				leadStrategyId: leadStrategyId,
				agentId: agentId,
				lastPageVisited: getLastVisitedPageCategory(investorNavState),
			},
			leadProfileId,
		);
	};

	const handleNextAmount = (data: IProfile) => {
		 //setLeadProfile(data);
		//LeadApi.redirectToPage$.next("investment_reason");
		onAddUpdateAmountReason({
			leadId: leadProfileId,
			leadStrategyId: leadStrategyId,
			riskProfileId: getRiskProfileId(),
			investmentAmount: data.investmentInfo ? data.investmentInfo.InvestmentAmount : 0,
			goalType: +(leadProfile.investmentReason || '0'),
			agentId: agentId,
		}, {
			currentRoute: "investment_amount",
			leadId: leadProfileId,
			leadStrategyId: leadStrategyId,
			agentId: agentId,
			lastPageVisited: getLastVisitedPageCategory(investorNavState),
		});
	};

	const handleNextReason = (data: IProfile) => {
		onAddUpdateAmountReason({
			leadId: leadProfileId,
			leadStrategyId: leadStrategyId,
			riskProfileId: getRiskProfileId(),
			investmentAmount: data.investmentInfo ? data.investmentInfo.InvestmentAmount : 0,
			goalType: +(data.investmentReason === "0" ? '2' : data.investmentReason || '2'),
			agentId: agentId,
		}, {
			currentRoute: "investment_reason",
			leadId: leadProfileId,
			leadStrategyId: leadStrategyId,
			agentId: agentId,
			lastPageVisited: getLastVisitedPageCategory(investorNavState),
		});
	};
	
	return (
		<div className={styles.aboutYouContainer}>
			<div className={styles.colFlex}>
				<div className={styles.sidebar}>
					<SideBarComponent screen={subModule} />
				</div>
				<div className="">
					{subModule === "about" && (<About
							onBackButtonClick={(e, data) => history.push("/")}
							onNextButtonClick={(e, data) => handleNextName(data)}
							data={leadProfileCopy}
						/>)}
					
					{subModule === "investment_amount" && (<InvestmentAmount
							onBackButtonClick={(e, data) => handleBackButton("about", data)}
							onNextButtonClick={(e, data) => handleNextAmount(data)}
							data={leadProfileCopy}
						/>)}

					{subModule === "investment_reason" && (<InvestmentReason
							onBackButtonClick={(e, data) => handleBackButton("investment_amount", data)}
							onNextButtonClick={(e, data) => handleNextReason(data)}
							investmentReasons={investmentTypeDropdownItems}
							data={leadProfileCopy}
							buttonLabel={[{ key: '1', back: 'BACK', next: 'NEXT' }]}
						/>)}
			
				</div>
			</div>
		</div>
	);
};
